<template>
  <div class="sites-popup" v-show="show">
      <div class="sites-container">
          <div class="sites-view">
              <div class="sites-title">当前地址需选择取餐点</div>
              <div class="sites-content">
                  <div 
                      v-for="(item, index) in areaList" 
                      :key="index"
                      :class="['site', {'active': selectKey === index} ]"
                      @click="selectSiteFn(index)"
                  >
                      {{ item.name }}
                  </div>
              </div>
              <div class="confirm" @click="confirmArea">确定</div>
          </div>
      </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "sitesDialog",
  props: {
      value: {
          default: false,
          type: Boolean
      },
      areaList: {
          type: Array,
          default: [
              { name: '东门' },
              { name: '东门' },
              { name: '东门' },
              { name: '东门' },
          ],
      }
  },
  data() {
      return {
          show: false,
          selectKey: null,
      }
  },
  watch: {
      value(val) {
          this.show = val;
      }
  },
  methods: {
      selectSiteFn(index) {// 选择取餐点
          this.selectKey = index;
      },
      confirmArea() {
          if (this.areaList[this.selectKey].location.length == 2 && this.areaList[this.selectKey].enabled) {
              this.$emit('selectedSite', this.areaList[this.selectKey])
          } else {
            Toast('请选择有效的取餐点')
          }
          
      }
  }
}
</script>

<style lang="scss" scoped>
.sites-popup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  .sites-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .sites-view {
          width: 80%;
          background: #FFF;
          border-radius: 10px;
          .sites-title {
              width: 100%; 
              height: auto;
              box-sizing: border-box;
              padding: 30px 25px 10px;
              font-size: 16px;
              font-weight: bolder;
          }
          .sites-content {
              width: 100%; 
              height: auto;
              max-height: 500px;
              box-sizing: border-box;
              padding: 0 15px 30px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              overflow: auto;
              .site {
                  width: 100px;
                  height: 40px;
                  margin: 10px;
                  border: 1px solid #ccc;
                  text-align: center;
                  line-height: 40px;
                  &.active {
                      border: #FF2E2E solid 1px;
                      color: #FF2E2E;
                  }

              }
          }
          .confirm {
              width: 100%; 
              height: 46px;
              box-sizing: border-box;
              border-top: 1px #ccc solid;
              text-align: center;
              line-height: 46px;
              font-size: 18px;
              color: #108ee9;

          }
      }
  }
}
</style>